import { useState, useCallback } from "react";
import moment from 'moment'
import {Card, Table} from "react-bootstrap";
import { Link } from 'react-router-dom';
import Button from "react-bootstrap/Button";

const calendarFormatOptions = {
    sameDay: '[Today], h:mm a',
    lastDay: '[Yesterday], h:mm a',
    lastWeek: 'MMM Do',
    sameElse: 'MMM Do'
}

const Activities = ({activities, getActivities, isLoading}) => {
    const loadMore = useCallback(() => {
        getActivities();
    }, [getActivities]);

    return (
    <div className="row">
        <Card className="col-md-12 col-lg-4 mt-4">
            <Card.Header
                as="h6"
                className="bg-white font-weight-bold"
            >
                Activity
            </Card.Header>
            <Card.Body>
                <Card.Text as="h6">
                    Recently Published Posts
                </Card.Text>

                {/* <Table borderless>
                    <tbody>
                        {activities.map((activity, index) => {
                            return(
                                <tr key={index}>
                                    <td
                                        style={{padding: '5px 0px', fontSize: 15}}
                                        width="150"
                                    >
                                        {moment.utc(activity.created_at).local().calendar(null, calendarFormatOptions)}
                                    </td>
                                    <td
                                        style={{padding: '5px 0px', fontSize: 15}}
                                        className="text-info"
                                    >
                                        <Link to={{pathname:`/${activity.user.login}?postid=${activity.id}#post-${activity.id}`}}>{activity.user.login}</Link>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table> */}

                <div className="d-flex flex-row mt-4" style={{minHeight: '200px', maxHeight: '600px', overflowY: 'scroll'}}>
                    <Table borderless>
                        <tbody>
                            {activities.map((activity, index) => {
                                return(
                                    <tr key={index}>
                                        <td
                                            style={{padding: '5px 0px', fontSize: 15}}
                                            width="150"
                                        >
                                            {moment.utc(activity.created_at).local().calendar(null, calendarFormatOptions)}
                                        </td>
                                        <td
                                            style={{padding: '5px 0px', fontSize: 15}}
                                            className="text-info"
                                        >
                                            <Link to={{pathname:`/${activity.username}?postid=${activity.id}#post-${activity.id}`}}>{activity.username}</Link>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                </div>

                <Button
                    variant="primary"
                    disabled={isLoading}
                    onClick={isLoading ? () => {} : () => loadMore()}
                    className="mt-2 ml-2 load-more-activities-btn"
                >
                    {isLoading ? "Fetching data..." : "Load More"}
                </Button>
            </Card.Body>
        </Card>
    </div>
  )
}

export default Activities;